import {useState, useEffect, useContext} from 'react'
import { UserStoreContext } from '../../Contexts/UserStoreContext';
import Axios from 'axios';
const useFetch = (request) => {
    const [data, setData] = useState(null);
    const[isLoading, setIsLoading] = useState(true);
    const[error, setError] = useState(null);
    
    
    const {is_logged_in, user_store} = useContext(UserStoreContext)
    

    useEffect(()=>{ 
        setError(null)
        setIsLoading(true)
        if(request){
            const url = '/geniuxmusic/api/like_dislike_comment_reply.php';
            let cancel
            Axios({
                method: 'post',
                url: url,
                data: {
                    commentId: request.commentId,
                    action: request.action,
                    myuserid: is_logged_in?user_store.user_id:"",
                    mytoken: is_logged_in?user_store.user_token:"",
                },
                cancelToken: new Axios.CancelToken(c => cancel = c),

            })
            
            .then(response=>{
                setIsLoading(false)
                if(response.data && response.data.length>0){
                    setData(response.data)
                    setError(null);  
                    
                }else{
                    setData(null)
                    setError('unknown_err');  
                }
           
               
            })
            .catch(err=>{
                setIsLoading(false)
                setError('network_err');   
            })
            return () => cancel()
        }else{
            setIsLoading(false)
        }
    
    
    },[request])
 
    return {data, isLoading, error}
}

export default useFetch
